function CompFooter() {
    return (
        <footer className="text-muted">
            <div className="container">
                <p className="float-right">
                    <a href="#top">Back to top</a>
                </p>
                <p>Album example is © Bootstrap, but please download and customize it for yourself!</p>
                <p>New to Bootstrap? <a href="https://getbootstrap.com/">Visit the homepage </a> 
                    or read our <a href="https://getbootstrap.com/docs/4.4/getting-started/introduction/">getting started guide</a>.
                </p>
            </div>
        </footer>
    )
}

export default CompFooter